import {
  AVAILABILITY_OPTIONS,
  INTERN_TRACKS,
  type InternApplication,
  type InternTrackId,
} from './types';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const TRACK_IDS = new Set(INTERN_TRACKS.map((t) => t.id));
const AVAILABILITY_VALUES = new Set(AVAILABILITY_OPTIONS.map((o) => o.value));

export function getInternApplicationErrors(
  application: InternApplication
): Record<string, string> {
  const errors: Record<string, string> = {};

  if (!application.firstName.trim()) errors.firstName = 'First name is required';
  if (!application.lastName.trim()) errors.lastName = 'Last name is required';

  const email = application.email.trim();
  if (!email) errors.email = 'Email is required';
  else if (!EMAIL_RE.test(email)) errors.email = 'Enter a valid email address';

  if (!application.school.trim()) errors.school = 'School or university is required';

  const year = application.graduationYear.trim();
  if (!year) errors.graduationYear = 'Expected graduation year is required';
  else if (!/^\d{4}$/.test(year) || Number(year) < 2024 || Number(year) > 2040) {
    errors.graduationYear = 'Enter a valid 4-digit year';
  }

  if (!application.major.trim()) errors.major = 'Major or field of study is required';

  if (!TRACK_IDS.has(application.track as InternTrackId)) {
    errors.track = 'Select a fellowship track';
  }

  if (!AVAILABILITY_VALUES.has(application.availability)) {
    errors.availability = 'Select your availability';
  }

  const why = application.whySelfLabs.trim();
  if (!why) errors.whySelfLabs = 'Tell us why you want to join the SELF Labs Fellowship';
  else if (why.length < 40) {
    errors.whySelfLabs = 'Please write at least 40 characters';
  }

  if (!application.consent) {
    errors.consent = 'You must agree to be contacted about this application';
  }

  return errors;
}
